const organizationDanish = {
  common: {
    loading: "Indlæser...",
    error: "Der opstod en fejl",
    save: "Gem",
    cancel: "Annuller",
    yes: "Ja",
    no: "Nej"
  },
  header: {
    title: "Organisation",
    adminRole: "Administrator",
    employeeRole: "Medarbejder",
    adminDescription: "Administrer din organisation, teammedlemmer og kundetildelinger",
    employeeDescription: "Se din organisation, teammedlemmer og kundetildelinger"
  },
  messages: {
    confirmRemoveMember: "Er du sikker på, at du vil fjerne {email} fra organisationen?",
    confirmCancelInvitation: "Er du sikker på, at du vil annullere denne invitation?",
    confirmCancelSubscription: "Er du sikker på, at du vil opsige dette abonnement?"
  },
  notifications: {
    success: {
      invitationSent: "Invitation sendt til {email}",
      memberRemoved: "Medlem fjernet fra organisationen",
      invitationCancelled: "Invitation annulleret",
      customerAssigned: "Kunde tildelt til medarbejder",
      assignmentRemoved: "Kundetildeling fjernet",
      licenseAdded: "Licenser tilføjet"
    },
    error: {
      general: "Der opstod en fejl",
      emailRequired: "Indtast venligst en email",
      noOrganization: "Ingen organisation fundet",
      memberExists: "Denne bruger er allerede medlem af organisationen",
      invitationExists: "Denne bruger er allerede inviteret til organisationen",
      billingPortal: "Der opstod en fejl ved åbning af kundeportalen. Prøv igen senere."
    }
  },
  subscription: {
    card: {
      title: "LinkedIn Poster Licenser",
      status: {
        active: "Aktiv",
        trialing: "Prøveperiode",
        inactive: "Inaktiv"
      },
      currentPlan: "Nuværende plan:",
      noPlan: "Ingen plan",
      licenseInfo: {
        total: "Totale licenser",
        assigned: "Tildelte licenser",
        available: "Tilgængelige licenser"
      },
      trial: {
        info: "Din prøveperiode udløber om"
      },
      actions: {
        addLicenses: "Tilføj licenser",
        manageBilling: "Administrer betaling"
      }
    }
  },
  team: {
    card: {
      title: "Team",
      inviteButton: "Inviter medlem",
      emptyState: {
        admin: "Dit team er tomt. Inviter teammedlemmer ved at klikke på \"Inviter medlem\" knappen.",
        employee: "Der er ingen teammedlemmer i organisationen endnu."
      },
      memberInfo: {
        you: "(Dig)",
        admin: "Administrator",
        member: "Medlem",
        status: {
          active: "Aktiv",
          invited: "Inviteret"
        },
        invitationBadge: "Invitation"
      }
    }
  },
  customerManagement: {
    card: {
      title: "Kundestyring",
      adminSubheader: "Tildel kunder til medarbejdere",
      employeeSubheader: "Oversigt over kunder og tildelinger",
      emptyState: {
        admin: "Der er ingen kunder i organisationen endnu. Inviter kunder ved at vælge \"Kunde\" i invitationsformularen.",
        employee: "Der er ingen kunder i organisationen endnu."
      },
      tableHeaders: {
        customer: "Kunde",
        email: "Email",
        status: "Status",
        assignedTo: "Tildelt til",
        actions: "Handlinger"
      },
      status: {
        active: "Aktiv",
        invited: "Inviteret"
      },
      notAssigned: "Ikke tildelt",
      actions: {
        assign: "Tildel kunde",
        removeAssignment: "Fjern tildeling"
      }
    }
  },
  modals: {
    assignLicense: {
      title: "Tildel Licens",
      email: "Email",
      licenseType: "Licenstype",
      availableLicenses: "Tilgængelige licenser:",
      licenseTypes: {
        basic: "Basic",
        pro: "Professional",
        enterprise: "Enterprise"
      }
    },
    updateSubscription: {
      title: "Opdater Abonnement",
      quantity: "Antal licenser",
      preview: {
        plan: "Plan:",
        pricePerLicense: "Pris per licens:",
        total: "Total:"
      }
    },
    inviteMember: {
      title: "Inviter Teammedlem",
      email: "Email",
      emailPlaceholder: "Indtast teammedlemmets email",
      role: "Rolle",
      roles: {
        employee: "Medarbejder (Kan styre egne og andres profiler)",
        customer: "Kunde (Kan kun logge ind med LinkedIn)"
      },
      info: "Der vil blive sendt en invitation til denne email. Når brugeren accepterer invitationen, vil de få tildelt en licens.",
      employeeInfo: " Som medarbejder kan de styre både egne og andres LinkedIn-profiler.",
      customerInfo: " Som kunde kan de kun logge ind med LinkedIn og vil ikke have adgang til dashboard.",
      availableLicenses: "Tilgængelige licenser:",
      sending: "Sender invitation...",
      send: "Send invitation"
    },
    buyLicense: {
      title: "Køb flere licenser",
      info: "Du skal købe flere licenser for at kunne invitere flere medlemmer. Du har i øjeblikket {currentLicenses} licens(er).",
      quantity: "Antal licenser at tilføje",
      pricing: {
        info: "Hver licens giver én plads til et teammedlem",
        price: "Pris: 1490 kr ekskl. moms/md. pr. licens (Der er mulighed for at skrive en rabatkode)",
        total: "Total: {total} kr ekskl. moms/md."
      },
      buy: "Køb licenser"
    },
    assignCustomer: {
      title: "Tildel Kunde: {customerName}",
      selectEmployee: "Vælg medarbejder",
      noEmployee: "Vælg medarbejder",
      assign: "Tildel Kunde"
    }
  }
};

export default organizationDanish; 